import CompanyDetails from '../../../../../packages/bk-web-app/client-details/CompanyDetails';

export default CompanyDetails;
